import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(({ styles }) =>
  css({
    display: 'flex',
    textAlign: 'center',
    py: ['xl', 'xl', '70px'],
    px: '0 !important',
    flexDirection: 'column',
    alignItems: 'center',
    gap: ['default', 'default', 'xl'],
    '& > *:last-child': {
      marginBottom: 0,
    },
    ...styles,
  }),
);

themeStyles.addBaseStyles('TitleContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: ['xs', 'xs', 's'],
    px: ['20px', '20px', '0 !important'],
  }),
);

themeStyles.addBaseStyles('SelectVehicleContainer')(
  css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: ['40px', '40px', 'xl'],
  }),
);

themeStyles.addBaseStyles('OwnerResourcesContainer')(
  css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    flexWrap: 'wrap',
    gap: '24px',
    justifyContent: 'center',
  }),
);

themeStyles.addBaseStyles('IconCardContainer')(
  css({
    mb: ['default', 'default', 'zero'],
    flex: ['0 1 100%', '0 1 100%', '0 1 30%'],
    minWidth: '280px',
  }),
);

themeStyles.addBaseStyles('DownloadLinkContainer')(({ styles }) =>
  css({
    py: 'xs',
    textAlign: 'left',
    alignItems: 'baseline',
    display: 'flex',
    ...styles,
  }),
);

themeStyles.addBaseStyles('DownloadWrapper')(
  css({
    scrollMarginTop: ['60px', '60px', '75px'],
  }),
);

export default themeStyles;
